export {
  HeaderSection,
  type HeaderSectionProps,
} from '../../compositions/shared/HeaderSection';
